import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { AssociativaAltrePartiForm } from '../../../form/associativa-altreparti-form';
import { AltraParte } from '../../../models/altraparte';
import { SezioneAltreParti } from '../../../models/sezioni/sezione-altre-parti';

declare var closeModal: any;

@Component({
    selector: 'div [associativa-altreparti-form-update]',
  templateUrl: '../../../form/associativa-altreparti-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})
export class AltrePartiUpdateAssociativaComponent extends AssociativaAltrePartiForm implements OnInit {
  altraparte: AltraParte;
  urlUpdate: string;
  idSezione: string;
  @Output() onReturn: EventEmitter<SezioneAltreParti> = new EventEmitter<SezioneAltreParti>();

  constructor(@Inject(FormBuilder) campiForm: FormBuilder, @Inject(OperationsService) operationService: OperationsService, @Inject(HelpersService) helpers: HelpersService) {
      super(operationService, campiForm, helpers);
  }
  ngOnInit() {
    this.setTitle('Modifica dati - Associativa');
    this.isInserimento(false);
  }

  inizializza(urlUpdate: string, altraparte: AltraParte, idSezione: string, urlSezioneControparti: string, idSezioneControparti: string) {
    this.altraparte = altraparte;
    this.urlUpdate = urlUpdate;
    this.idSezione = idSezione;
    this.populateSelect(urlSezioneControparti, idSezioneControparti);
    this.createForm();
  }

  getAltraParte(): AltraParte {
    return this.altraparte;
  }

  getRequest(request: AltraParte) {
    this.operationService.updateAssociativaAltraParte(this.urlUpdate, request, this.idSezione).subscribe(response => this.manageUpdate(response));
  }

  manageUpdate(response) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }
}
